import type { GridRowId } from '@mui/x-data-grid-premium';
import { LineItemMetrics, type LineItemPricingBasis } from '@shared/core/lineItem';
import type { LineItemAttributes } from 'types/graphql';

export const PRODUCTS_GRID_ID = 'products-grid';

/**
 * Creates a draft row selector for sub groupings, by ensuring the
 * parentLineItemIds match up.
 */
export const subGroupDraftRowSelector =
  (parentLineItemId: GridRowId | null) =>
  (rowToCompare: Record<string, unknown>): boolean =>
    rowToCompare.isNew === true && rowToCompare.parentLineItemId === parentLineItemId;

export type ProductLineItemRows = LineItemAttributes[];

/** Sum the picked units across a parent's child sub-lots. Returns `undefined` when no child has been picked, so the unpicked "--" state is preserved rather than collapsing to 0. */
export const aggregateChildrenUnitsPicked = (
  children: ReadonlyArray<{ unitsPicked?: number | null }>
): number | undefined => {
  const anyPicked = children.some((child) => child.unitsPicked !== null && child.unitsPicked !== undefined);

  if (!anyPicked) {
    return undefined;
  }

  return children.reduce((acc, child) => acc + (child.unitsPicked ?? 0), 0);
};

export const getLineItemPricingQuantity = <T extends LineItemPricingBasis>(
  lineItem: T,
  quantities: { units?: number | null; weight?: number | null }
): number | null | undefined => (LineItemMetrics.isPricedByWeight(lineItem) ? quantities.weight : quantities.units);
